"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsNewCustomerProfileEntity = void 0;
const AnalyticsNewCustomerProfileDto_1 = require("./AnalyticsNewCustomerProfileDto");
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class AnalyticsNewCustomerProfileEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, analyticsNewCustomerProfile) {
        super();
        this._requiredFieldsSetStatus = {
            appId: false,
            locationId: false,
            locationName: false,
            adjustmentTotal: false
        };
        this._dependencies = dependencies;
        if (analyticsNewCustomerProfile === undefined) {
            this._dto = new AnalyticsNewCustomerProfileDto_1.AnalyticsNewCustomerProfileDto();
        }
        else if (analyticsNewCustomerProfile instanceof AnalyticsNewCustomerProfileDto_1.AnalyticsNewCustomerProfileDto) {
            this._dto = new AnalyticsNewCustomerProfileDto_1.AnalyticsNewCustomerProfileDto(analyticsNewCustomerProfile);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (analyticsNewCustomerProfile instanceof AnalyticsNewCustomerProfileEntity) {
            this._dto = new AnalyticsNewCustomerProfileDto_1.AnalyticsNewCustomerProfileDto(analyticsNewCustomerProfile._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new AnalyticsNewCustomerProfileDto_1.AnalyticsNewCustomerProfileDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    getAppId() {
        return this._dto.appId;
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getLocationName() {
        return this._dto.locationName;
    }
    setLocationName(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = "";
        if (typeof untrustedValue !== "string") {
            throw new Error("setLocationName(): Invalid type");
        }
        _untrustedValue = untrustedValue.trim();
        this.clearError("locationName");
        this._requiredFieldsSetStatus.locationName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("locationName", "Location Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("locationName", `Location Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationName) {
            return;
        }
        this._dto.locationName = _untrustedValue;
        this._setIsDirty(true);
    }
    getDate() {
        return this._dto.date;
    }
    getTotal() {
        return this._dto.total;
    }
    setAdjustTotal(untrustedValue) {
        let _untrustedValue;
        this.clearError("adjustmentTotal");
        this._requiredFieldsSetStatus.adjustmentTotal = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("adjustmentTotal", "Adjustment Total is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined) {
            this.addError(new ValidationError_1.ValidationError("adjustmentTotal", "Adjustment Total is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.adjustmentTotal) {
            return;
        }
        if (_untrustedValue === null) {
            delete this._dto.adjustmentTotal;
            this._setIsDirty(true);
        }
        else {
            this._dto.adjustmentTotal = _untrustedValue;
            this._setIsDirty(true);
        }
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.analyticsNewCustomerProfileDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let dto;
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.canSave) {
                    throw new Error("Analytics New Customer Profile is not in a valid state.");
                }
                if (this.isNew) {
                    dto = yield this._dependencies.analyticsNewCustomerProfileDatastore
                        .addAsync(this._dto);
                }
                else {
                    dto = yield this._dependencies.analyticsNewCustomerProfileDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.total = dto.total;
                delete this._dto.adjustmentTotal;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AnalyticsNewCustomerProfileEntity = AnalyticsNewCustomerProfileEntity;
//# sourceMappingURL=AnalyticsNewCustomerProfileEntity.js.map